import { Component, ViewChild, ViewEncapsulation } from '@angular/core';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { environment } from '~environment';
import { Input } from '@angular/core/src/metadata/directives';

const PROPERTY_DETAILS_URL = `${environment.staticFiles}`;
const PLAY_ICON_URL = PROPERTY_DETAILS_URL + '/images/play_circle_outline_grey_192x192.png';
const THUMBNAIL_IMAGE = PROPERTY_DETAILS_URL + '/images/Keith-Video-Snapshot.png';

@Component({
  selector: 'idap-learn-more-modal',
  templateUrl: './learn-more-modal.component.html',
  styleUrls: ['./learn-more-modal.component.scss'],
  animations: [
    trigger('fadeInOut', [
      transition('void => *', [
        style({ opacity: 0 }), //style only for transition transition (after transiton it removes)
        animate(500, style({ opacity: 1 })) // the new state of the transition(after transiton it removes)
      ])
    ])
  ],
  encapsulation: ViewEncapsulation.None
})
export class LearnMoreModalComponent {
  @ViewChild('videoPlayer') videoplayer: any;
  width = '1000px';

  toggle: boolean = true;
  playIconUrl = PLAY_ICON_URL;
  videoUrl = PROPERTY_DETAILS_URL + '/videos/UA_KeithDunkin.mp4';
  thumbnailImageUrl = THUMBNAIL_IMAGE;

  constructor(public activeModal: NgbActiveModal) { }

  toggleVideo(event: any) {
    this.toggle = !this.toggle;

    if (this.videoplayer.nativeElement.paused) {
      this.videoplayer.nativeElement.play();
    } else {
      this.videoplayer.nativeElement.pause();
    }
  }

  videoEnd(event: any) {
    this.toggle = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/layout/learn-more-modal.component.ts